import { FC } from 'react'

import { buildShareUrl, ServiceEnum } from 'utils'
import { IconTelegram } from 'components/icons/telegram'
import { IconEmail } from 'components/icons/email'
import { IconFacebook } from 'components/icons/facebook'
import { IconOdnoklassniki } from 'components/icons/odnoklassniki'
import { IconTwitter } from 'components/icons/twitter'
import { IconVk } from 'components/icons/vk'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { IconShare } from 'components/icons/share'
import { MobileHidden, MobileOnly } from '../menu/styled'
import {
  CloseButton,
  ShareButton,
  ShareContainer,
  ShareMenu,
  ShareMenuWrapper,
} from './styled'
import { useDataContext } from 'context/data-context'

const shareOptions = [
  { component: IconFacebook, service: 'facebook' },
  { component: IconTwitter, service: 'twitter' },
  { component: IconVk, service: 'vk' },
  { component: IconEmail, service: 'email' },
  { component: IconOdnoklassniki, service: 'odnoklassniki' },
  { component: IconTelegram, service: 'telegram' },
  { component: IconWhatsapp, service: 'whatsapp' },
]

type Props = {
  isOpen: boolean
  onToggle: () => void
}

export const Share: FC<Props> = ({ onToggle, isOpen }) => {
  const { translate } = useDataContext()

  return (
    <ShareContainer isOpen={isOpen}>
      <ShareButton onClick={onToggle}>
        <MobileHidden>{translate('Share')}</MobileHidden>
        <MobileOnly>
          <IconShare />
        </MobileOnly>
      </ShareButton>

      <ShareMenuWrapper>
        <ShareMenu>
          {shareOptions.map((item) => (
            <li key={item.service}>
              <a
                href={buildShareUrl(item.service as ServiceEnum)}
                target="_blank"
                rel="noreferrer"
              >
                <item.component />
              </a>
            </li>
          ))}
          <CloseButton>
            <button onClick={onToggle}></button>
          </CloseButton>
        </ShareMenu>
      </ShareMenuWrapper>
    </ShareContainer>
  )
}
